import type { QuotaOperationState } from "app/pages/sales-intelligence/modules/quota/types";

export enum ContactsAvailabilityStatus {
    FullAccess = 1,
    Readonly = 2,
    PendingApproval = 3,
    DisabledByCountry = 4,
    DisabledByAccount = 5,
}

export type ContactsStatus = {
    quota: QuotaOperationState;
    hasRevealedContacts: boolean;
    availability: ContactsAvailabilityStatus;
};

export type ContactsDepartments =
    | "ACCOUNTING"
    | "FINANCE"
    | "BUSINESS"
    | "CLIENT SUCCESS"
    | "HR"
    | "HUMAN RESOURCES"
    | "OPERATIONS"
    | "SALES"
    | "MARKETING"
    | "IT"
    | "ENGINEERING"
    | "ENGINEERING & TECHNICAL"
    | "DESIGN"
    | "PRODUCT"
    | "PRODUCTION"
    | "TECHNOLOGY"
    | "INFORMATION TECHNOLOGY"
    | "LEGAL"
    | "CUSTOMER SUPPORT"
    | "LEADERSHIP"
    | "OVERSIGHT"
    | "C-SUITE"
    | "OTHER";

export type ContactsTabCountriesDto = {
    contactsCountries: {
        country: { id: number; name: string };
        contactsCount: number;
    }[];
};

export type EmployeeProfilesDescriptionDto = {
    employeeProfile: {
        departments: readonly string[];
        seniority: readonly string[];
    };
};
